import { NOOP } from '../const.js'
import { RowsConfig } from '../types.js'
import { getGristEventHandler } from '../handlers/index.js'

export const buildRowsOptions = (rows: any): RowsConfig => {
  var {
    appendable = true,
    editable = true,
    insertable = false,
    selectable,
    groups = [],
    totals = [],
    classifier,
    accumulator
  } = rows

  /* handler */
  var { click, dblclick, focus } = rows.handlers || {}
  if (typeof classifier !== 'function') {
    classifier = NOOP
  }

  return {
    accumulator,
    appendable,
    editable,
    insertable,
    selectable,
    groups,
    totals,
    handlers: {
      click: getGristEventHandler(click),
      dblclick: getGristEventHandler(dblclick),
      focus: getGristEventHandler(focus)
    },
    classifier
  }
}
